import { StorageKeys } from "constants/storageKeys";

const defaultPage = 0;
const defaultPageSize = 10;
const defaultFiltered = [];
const defaultSorted = [];

export const DEBOUNCE_MILLISECONDS = 300;

export const saveSearchParam = (storageKey, page, pageSize, filtered, sorted,) => {
  try {
    sessionStorage.setItem(
      storageKey,
      JSON.stringify({page, pageSize, filtered, sorted,})
    );
  } catch (e) { }
}

export const getPage = (storageKey) => {
  try {
    const page = JSON.parse(sessionStorage.getItem(storageKey)).page;
    return page;
  } catch (e) {
    return defaultPage;
  }
};

export const getPageSize = (storageKey) => {
  try {
    const pageSize = JSON.parse(sessionStorage.getItem(storageKey)).pageSize;
    return pageSize;
  } catch (e) {
    return defaultPageSize;
  }
};

export const getFiltered = (storageKey) => {
  try {
    return JSON.parse(sessionStorage.getItem(storageKey)).filtered;
  } catch (e) {
    return defaultFiltered;
  }
};

export const getSorted = (storageKey) => {
  try {
    return JSON.parse(sessionStorage.getItem(storageKey)).sorted;
  } catch (e) {
    return defaultSorted;
  }
};

export const clearAllFilters = () => {
  try {
    for (const key in StorageKeys.ReactTableFilters) {
      sessionStorage.removeItem(StorageKeys.ReactTableFilters[key]);
    }
  } catch (e) { }
}